import { transport } from 'config/transport';

export function callApiExportBanNganhReportForTrungUong(academicYear) {
    return transport.get(`/trunguong/report/bannganh`, { params: { academicYear }, responseType: 'blob' });
}
